import CompareAtPrice from '../CompareAtPrice';
import SalePrice from '../SalePrice';

const Price = (props) => {
  const { variant, hidePrice, settings, showVariantTitle } = props;

  if (hidePrice) {
    return null;
  }
  return (
    <div className="c7-product__variant__price">
      <CompareAtPrice
        variant={variant}
        settings={settings}
        showVariantTitle={showVariantTitle}
      />
      <SalePrice
        variant={variant}
        settings={settings}
        showVariantTitle={showVariantTitle}
      />
    </div>
  );
};

export default Price;
